import { Space, Button } from 'antd';
import React, { useEffect, useRef } from 'react';
import IOAIcon from '@/assets/images/login/ioa.react.svg?react';
import { IOA_CALLBACL_URL, IOA_LOGIN_URL, IOA_PAASID } from '@/presentation/pages/login/constant';
import { redirectToPrevPage } from '@/presentation/pages/login/utils';
import styles from './index.module.scss';

export const IOALogin = () => {
  const windowRef = useRef<Window | null>(null);
  const interval = useRef<any>(null);

  const ioaLogin = () => {
    const redirectURL = new URL(IOA_LOGIN_URL);
    redirectURL.searchParams.append('url', IOA_CALLBACL_URL);
    redirectURL.searchParams.append('appkey', IOA_PAASID);

    windowRef.current = window.open(redirectURL.toString());
    monitorWindowCloseState();
  };

  const monitorWindowCloseState = () => {
    interval.current = setInterval(() => {
      if (windowRef.current?.closed) {
        // todo 登录后，新开页面自动关闭，这边处理登录后逻辑
        windowRef.current = null;
        redirectToPrevPage();
      }
    }, 1000);
  };

  useEffect(() => () => {
    interval.current = null;
    clearInterval(interval.current);
  }, []);

  return (
    <div className={styles.ioaForm}>
      <Space size={18}>
        <IOAIcon />
        <span className={styles.title}>腾讯iOA</span>
      </Space>
      <div className={styles.desc}>
        <p>监测到您当前处于内网环境</p>
        <p>建议使用iOA快速登录</p>
      </div>
      <Button type={'primary'} className={styles.submit} onClick={ioaLogin}>iOA登录</Button>
      {/* <Divider plain className={styles.split}>其他登录方式</Divider>*/}
    </div>
  );
};
